var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sidebar-right",
    {
      class: [
        "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--720",
        { open: _vm.show },
      ],
      on: { overlayClicked: _vm.outside },
    },
    [
      _c("div", { staticClass: "bg-white md__card--holder" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            {
              staticClass: "card-header",
              class: {
                "blue-class": _vm.$route.name == "projects",
                "green-class": _vm.$route.name == "tasks.home",
                "yellow-class": _vm.$route.name == "timesheet.home",
              },
            },
            [
              _c("h4", { staticClass: "h3 mb-0" }, [
                _vm._v(_vm._s(_vm.editTitle)),
              ]),
            ]
          ),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              { staticClass: "hideBlockParent" },
              [
                _c("div", { staticClass: "form-group mb-4" }, [
                  _c("label", [_vm._v("Name")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.task.name,
                        expression: "task.name",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "exampleFormControlInput1",
                      type: "text",
                      placeholder: "Requirement Name",
                    },
                    domProps: { value: _vm.task.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.task, "name", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "form-group mb-4" },
                  [
                    _c("label", [_vm._v("Description")]),
                    _c("html-editor", {
                      model: {
                        value: _vm.task.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.task, "description", $$v)
                        },
                        expression: "task.description",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "base-button",
                  {
                    staticClass: "my-4 btn-block",
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSubmit },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.editId && _vm.editId != undefined
                          ? "Update" + _vm.editId
                          : "Create"
                      )
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }